/* Builds alpha masks from the header's existing inline SVGs.
   Runs once, only on a product page with a transparent header.
   No scroll listeners — the compositor does the live work. */
(function () {
  var header = document.querySelector('x-header.header');
  if (!header) return;

  // Bail on any page that isn't a transparent-header PDP.
  // (Breakpoint is left to CSS so rotating the phone just works.)
  if (!document.querySelector(
    '#main .shopify-section:first-child.shopify-section--main-product [allow-transparent-header]'
  )) return;

  // Serialise an <svg> into a data-URI whose alpha IS the icon shape.
  // currentColor means nothing in a mask, so force opaque paint.
  function svgMask(svg) {
    var c = svg.cloneNode(true);
    c.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    if (c.getAttribute('stroke') && c.getAttribute('stroke') !== 'none') {
      c.setAttribute('stroke', '#000');
    }
    Array.prototype.forEach.call(c.querySelectorAll('*'), function (n) {
      if (n.hasAttribute('stroke') && n.getAttribute('stroke') !== 'none') n.setAttribute('stroke', '#000');
      if (n.hasAttribute('fill')   && n.getAttribute('fill')   !== 'none') n.setAttribute('fill',   '#000');
    });

    return 'url("data:image/svg+xml,' +
      encodeURIComponent(new XMLSerializer().serializeToString(c)) + '")';
  }

  function wrap(svg) {
    if (!svg || (svg.parentNode && svg.parentNode.classList.contains('ink-negative'))) return;
    var span = document.createElement('span');
    span.className = 'ink-negative';
    span.style.setProperty('--ink-mask', svgMask(svg));
    svg.parentNode.insertBefore(span, svg);
    span.appendChild(svg);
    return span;
  }

  // Hamburger, search, cart (account is sm-max:hidden on mobile)
  Array.prototype.forEach.call(header.querySelectorAll('.header__nav-icon'), wrap);

  // Favourites heart — its shape changes when it fills, so rebuild then.
  var heart = header.querySelector('#header-favourites-icon');
  if (heart) {
    var heartSpan = wrap(heart);
    if (heartSpan) {
      new MutationObserver(function () {
        heartSpan.style.setProperty('--ink-mask', svgMask(heart));
      }).observe(heart, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // Logo — masked by the transparent logo's own PNG alpha.
  var logoLink = header.querySelector('.header__logo');
  var tLogo    = header.querySelector('.header__logo-image--transparent');
  if (logoLink && tLogo) {
    var setLogoMask = function () {
      logoLink.style.setProperty('--ink-mask', 'url("' + (tLogo.currentSrc || tLogo.src) + '")');
      logoLink.classList.add('ink-negative-logo');
    };
    if (tLogo.complete && tLogo.naturalWidth) setLogoMask();
    else tLogo.addEventListener('load', setLogoMask, { once: true });
  }
})();